import { useCallback } from 'react';
import { PersonalDetailsFormGroup } from '../types';

const usePersonalClientFormHelper = () => {
  const isPersonalDetailsValid = useCallback((formGroup: PersonalDetailsFormGroup) => {
    return (
      !formGroup.getFieldMeta('personalNumber').error &&
      !formGroup.getFieldMeta('fullName').error &&
      !formGroup.getFieldMeta('address').error &&
      !formGroup.getFieldMeta('phoneNumber').error &&
      !formGroup.getFieldMeta('email').error
    );
  }, []);

  return {
    isPersonalDetailsValid,
  };
};

export default usePersonalClientFormHelper;
